
import { Link } from 'react-router-dom';
import { Settings } from 'lucide-react';

export default function Header() {
  return (
    <header className="bg-white/95 backdrop-blur-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3 group">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20logo%20design%20for%20virtual%20party%20rule%20chat%20service%2C%20featuring%20dice%20and%20chat%20bubble%20elements%2C%20gradient%20blue%20to%20teal%20colors%2C%20clean%20geometric%20shapes%2C%20professional%20gaming%20aesthetic%2C%20white%20background%2C%20vector%20style%20illustration%2C%20contemporary%20design&width=64&height=64&seq=logo-header&orientation=squarish"
                alt="バーチャルパーティールール確認チャット ロゴ"
                className="h-10 w-10 object-contain group-hover:scale-110 transition-transform duration-200"
              />
              <h1 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent" style={{ fontFamily: '"Pacifico", serif' }}>
                バーチャルパーティールール確認チャット
              </h1>
            </Link>
          </div>
          
          <div className="flex items-center space-x-6">
            <p className="text-sm text-gray-600 hidden sm:block font-medium">
              遊ぶゲームを選んで、ルールをAIに質問できます
            </p>
            <Link
              to="/admin/login"
              className="flex items-center space-x-2 text-sm text-gray-600 hover:text-gray-900 transition-colors group"
            >
              <Settings className="h-4 w-4 group-hover:rotate-90 transition-transform duration-200" />
              <span>管理者ログイン</span>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
